<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'member' }" ripple>{{ $t('gpf_member') }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'member'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/GpfBuddy/MainMenu.vue